<template>
  <div>
    <section class="destination">
      <h1>{{ destination.name }}</h1>
      <GoBack />
      <div class="destination-details">
        <img
          :src="require(`@/assets/${destination.image}`)"
          :alt="destination.name"
        />
        <p>{{ destination.description }}</p>
      </div>
    </section>
    <section class="experiences" id="experiences">
      <h2>Top experiences in {{ destination.name }}</h2>
      <div class="cards">
        <router-link
          v-for="experience in destination.experiences"
          :key="experience.slug"
          :to="{
            name: 'ExperienceDetails',
            params: {
              experienceSlug: experience.slug,
            },
          }"
        >
          <ExperienceCard :experience="experience" />
        </router-link>
      </div>
      <router-view />
    </section>
  </div>
</template>
<script>
import sourceData from "@/data";
import ExperienceCard from "@/components/ExperienceCard";
import GoBack from "@/components/GoBack";
export default {
  components: { ExperienceCard, GoBack },
  props: {
    id: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },
  computed: {
    destination() {
      return sourceData.destinations.find(
        (destination) => destination.slug == this.slug
      );
    },
  },
};
</script>
